import { render, staticRenderFns } from "./stepCoverImage.vue?vue&type=template&id=4fe05f3c&scoped=true&"
import script from "./stepCoverImage.vue?vue&type=script&lang=js&"
export * from "./stepCoverImage.vue?vue&type=script&lang=js&"
import style0 from "./stepCoverImage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./stepCoverImage.vue?vue&type=style&index=1&id=4fe05f3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe05f3c",
  null
  
)

export default component.exports